<script setup lang="ts">
import { inject, type Ref } from 'vue'
import { useRouter } from 'vue-router'
import Title from '@/components/Title.vue'
import ContainerHeading from '@/components/Heading/ContainerHeading.vue'
import type { Container } from '@/models/Container'
import WarningMessage from '@/components/WarningMessage/WarningMessage.vue'

const router = useRouter()

const container = inject('container') as Ref<Container | null>

const cancel = () => {
  container.value = null
  router.push({ name: 'weigh-container-scan' })
}
const ok = () => {
  router.push({ name: 'weigh-container-scan' })
}
</script>

<template>
  <div class="page weigh-container-assigned">
    <Title>Peser un bac</Title>
    <ContainerHeading></ContainerHeading>
    <WarningMessage @ok="ok" @cancel="cancel">
      <template #message>Attention, l'état actuel de ce bac est : « ASSIGNÉ »</template>
      <template #question>Souhaitez-vous continuer ?</template>
    </WarningMessage>
  </div>
</template>
